import { useMemo, useState } from "react";
import OrdersList from "./OrdersList";

const MyOrders = ({ account }) => {
  return (
    <div className="mt-6 flex flex-col items-start justify-start gap-6 w-full">
      {account.length > 0 && <OrdersList list={account} />}
    </div>
  );
};

export default MyOrders;
